import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Select, Table } from 'antd';
import { Button } from '@cropler/ui-kit';
import { Icon as CroplerIcon } from '@cropler/ui-kit';


import Panel from '../Panel/index.jsx';

import styles from './styles.module.scss';
import stylesModal from '../../styles/modal.module.scss';
import stylesDashboard from '../../styles/dashboard.module.scss';

import {
  membershipsApi,
  useDeleteWorkspaceInvitationMutation,
  useDeleteWorkspaceMembershipMutation,
  useGetWorkspaceInvitationsQuery,
  useGetWorkspaceMembershipsQuery,
  useUpdateRoleWorkspaceMembershipMutation,
  useUpdateWorkspaceInvitationMutation,
} from '../../store/api/memberships';
import { MembersPanel } from './index.jsx';
import { getRoles } from '../../utils/ui';
import { useTranslation } from 'react-i18next';
import { GetMembersColumns } from './libs/index.jsx';

const Members = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const Roles = getRoles(t);
  const Columns = GetMembersColumns(t);

  const { currentUserId, currentUserRole } = useSelector((state) => state.auth);

  const [activeAddPanel, setActiveAddPanel] = useState(false);
  const [{ activeDeleteModal, isInvitationDeleteModal }, setActiveDeleteModal] = useState({
    activeDeleteModal: false,
    isInvitationDeleteModal: false,
  });
  const [selectedMemberId, setSelectedMemberId] = useState('');
  const [data, setData] = useState([]);

  const { isSuccess: isWorkspaceMembershipsSuccess, data: memberships = [] } = useGetWorkspaceMembershipsQuery();
  const { isSuccess: isWorkspaceInvitationsSuccess, data: invitations = [] } = useGetWorkspaceInvitationsQuery();
  const [deleteWorkspaceMember, { isSuccess: isSuccessDeleteMember }] = useDeleteWorkspaceMembershipMutation();
  const [deleteWorkspaceInvitation, { isSuccess: isSuccessDeleteInvitation }] = useDeleteWorkspaceInvitationMutation();
  const [updateWorkspaceMemberRole] = useUpdateRoleWorkspaceMembershipMutation();
  const [updateWorkspaceInvitationRole] = useUpdateWorkspaceInvitationMutation();

  const roles = Roles.filter((item) => item.value !== 'owner');

  const onOpenAddPanel = () => {
    setActiveAddPanel(true);
  };

  const showDeleteModal = ({ id, isInvitation }) => {
    setSelectedMemberId(id);
    setActiveDeleteModal({ activeDeleteModal: true, isInvitationDeleteModal: isInvitation });
  };

  const closeDeleteModal = () => {
    setActiveDeleteModal({ activeDeleteModal: false, isInvitationDeleteModal: false });
  };

  const deleteMember = () => {
    deleteWorkspaceMember({ workspaceMembershipId: selectedMemberId });
    closeDeleteModal();
  };

  const deleteInvitation = () => {
    deleteWorkspaceInvitation({ invitationId: selectedMemberId });
    closeDeleteModal();
  };

  const changeRole = (value, event) => {
    updateWorkspaceMemberRole({ workspaceMembershipId: event.id, role: value });
  };

  const changeInvitationRole = (value, event) => {
    updateWorkspaceInvitationRole({ invitationId: event.id, role: value });
  };

  useEffect(() => {
    if (isWorkspaceMembershipsSuccess && isWorkspaceInvitationsSuccess) {
      let list = [];

      //memberships
      if (isWorkspaceMembershipsSuccess) {
        memberships.map((item, index) => {
          list.push({
            key: (index + 1).toString(),
            name: item.user.first_name ? (
              item.user.first_name + ' ' + item.user.last_name
            ) : (
              <span className={stylesDashboard.textMuted}>{t('empty.noName')}</span>
            ),
            email: <strong>{item.user.email}</strong>,
            status:
              item.user.status === 'pending' ? <span className={stylesDashboard.tag}>{t('common.invited')}</span> : '',
            role: (
              <div className={styles.membersTableActions}>
                <div className={styles.membersTableActionsField}>
                  {item.role === 'owner' ? (
                    t('roles.owner')
                  ) : currentUserRole === 'owner' ? (
                    <Select
                      className={`select-compact select-outlined ${styles.membersTableActionsSelect}`}
                      suffixIcon={<CroplerIcon name="down" />}
                      size="small"
                      variant={'outlined'}
                      defaultValue={item.role}
                      style={{ width: 'auto' }}
                      onChange={changeRole}
                      options={roles.map((role) => ({
                        label: role.name,
                        value: role.value,
                        id: item.id,
                      }))}
                    />
                  ) : (
                    item.role
                  )}
                </div>
              </div>
            ),
            actions:
              (currentUserRole === 'owner' || currentUserId === item.user.id) && item.role !== 'owner' ? (
                <Button
                  type="default"
                  size="small"
                  icon={<CroplerIcon name="remove" />}
                  onClick={() => showDeleteModal({ id: item.id, isInvitation: false })}
                />
              ) : (
                ''
              ),
          });
        });
        setData(list);
      }

      // invitations
      if (isWorkspaceInvitationsSuccess && invitations.length) {
        invitations.map((item, index) => {
          list.push({
            key: (list.length + index + 1).toString(),
            name: <span className={stylesDashboard.textMuted}>{t('empty.noName')}</span>,
            email: <strong>{item.email}</strong>,
            status: <span className={stylesDashboard.tag}>{t('common.invited')}</span>,
            role: (
              <div className={styles.membersTableActions}>
                <div className={styles.membersTableActionsField}>
                  {currentUserRole === 'owner' ? (
                    <Select
                      className={`select-compact select-outlined ${styles.membersTableActionsSelect}`}
                      suffixIcon={<CroplerIcon name="down" />}
                      size="small"
                      defaultValue={item.role}
                      style={{ width: 'auto' }}
                      onChange={changeInvitationRole}
                      options={roles.map((role) => ({
                        label: role.name,
                        value: role.value,
                        id: item.id,
                      }))}
                    />
                  ) : (
                    item.role
                  )}
                </div>
              </div>
            ),
            actions: memberships.find(
              (m) => m.user.id === currentUserId && (m.role === 'owner' || m.role === 'dealer'),
            ) ? (
              <Button
                type="default"
                size="small"
                icon={<CroplerIcon name="remove" />}
                onClick={() => showDeleteModal({ id: item.id, isInvitation: true })}
              />
            ) : (
              ''
            ),
          });
        });
        setData(list);
      }
    }
  }, [isWorkspaceInvitationsSuccess, isWorkspaceMembershipsSuccess]);

  useEffect(() => {
    if (isSuccessDeleteInvitation) {
      dispatch(membershipsApi.util.resetApiState());
    }
  }, [isSuccessDeleteInvitation]);

  useEffect(() => {
    if (isSuccessDeleteMember) {
      dispatch(membershipsApi.util.resetApiState());
    }
  }, [isSuccessDeleteMember]);

  return (
    <div className={styles.membersContainer}>
      {activeAddPanel && (
        <Panel title={t('members.invite')} setActivePanel={() => setActiveAddPanel(false)}>
          <MembersPanel setActiveAddPanel={setActiveAddPanel} t={t} />
        </Panel>
      )}
      <div className={styles.membersHeader}>
        {/*<div className={styles.membersTitleWrapper}>*/}
        {/*  <h2 className={styles.membersTitle}>Workspace Members</h2>*/}
        {/*  <div className={stylesDashboard.label}>{memberships.length}</div>*/}
        {/*</div>*/}

        {(currentUserRole === 'owner' || currentUserRole === 'dealer') && (
          <Button type="secondary" icon={<CroplerIcon name="add" />} onClick={() => onOpenAddPanel()} size={'large'}>
            {t('members.invite')}
          </Button>
        )}
      </div>
      <div className={styles.membersBody}>
        {data && (
          <Table
            columns={Columns}
            dataSource={data}
            pagination={false}
            rootClassName={`${styles.membersTable} membersTable`}
          ></Table>
        )}
      </div>

      <Modal
        title={t('common.areYouSure')}
        open={activeDeleteModal}
        onCancel={() => closeDeleteModal()}
        footer={false}
        centered
        width={450}
      >
        <p dangerouslySetInnerHTML={{ __html: t('members.deleteText') }}></p>
        <div className={stylesModal.modalNav}>
          <Button type="secondary" onClick={() => closeDeleteModal()}>
            {t('actions.cancel')}
          </Button>
          <Button
            type="danger"
            icon={<CroplerIcon name="check" height={18} />}
            onClick={() => (isInvitationDeleteModal ? deleteInvitation() : deleteMember())}
          >
            {t('actions.delete')}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default Members;
